var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "temperature",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 31.632,
    height: 56,
    fill: "none"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(32 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M13.707,56A13.706,13.706,0,0,1,7.474,30.086V0H19.941V30.086A13.706,13.706,0,0,1,13.707,56M9.474,2V31.359l-.588.266a11.708,11.708,0,1,0,9.643,0l-.588-.266V2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 5.025,
    height: 44.411,
    transform: "translate(11.195 3.921)",
    fill: "#f05b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M23.3,42.529a9.6,9.6,0,1,1-9.6-9.6,9.6,9.6,0,0,1,9.6,9.6",
    fill: "#f05b66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 6.471,
    height: 2,
    transform: "translate(23.161 0.118)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 8.471,
    height: 2,
    transform: "translate(23.161 5.365)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 6.471,
    height: 2,
    transform: "translate(23.161 26.353)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 6.471,
    height: 2,
    transform: "translate(23.161 10.612)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 6.471,
    height: 2,
    transform: "translate(23.161 21.106)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 8.471,
    height: 2,
    transform: "translate(23.161 15.859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.bcc3cba2fce6f4d9881558099af8bd22.svg";
export { ForwardRef as ReactComponent };